import { el } from "../utils/dom.ts";
import { EVENT_TYPE_LABELS, type EventType } from "../../functions/_shared/event-taxonomy.ts";
import type { EventItem } from "../services/api-client.ts";

// Shared event-card renderer used by both the province timeline and the
// domain-insight blocks. Single implementation so the XSS-sensitive bits (title
// as a text node, https-scheme guard on the source href) can't drift between
// surfaces. Optional province link is opt-in (the province page is already
// scoped to one province, so it omits it).
export function eventCard(
  ev: EventItem,
  opts: { onProvinceClick?: (code: string) => void; provinceName?: (code: string) => string } = {},
): HTMLElement {
  const typeLabel = EVENT_TYPE_LABELS[ev.event_type as EventType] ?? ev.event_type;

  const metaChildren: (Node | string)[] = [
    el("span", { className: "event-type" }, [typeLabel]),
    el("span", { className: "event-sev" }, [`Mức ${ev.severity}`]),
  ];
  if (ev.province_code && opts.onProvinceClick) {
    const code = ev.province_code;
    const label = opts.provinceName?.(code) ?? `Tỉnh ${code}`;
    metaChildren.push(
      el("button", {
        className: "event-province-link",
        onclick: () => opts.onProvinceClick?.(code),
      }, [label]),
    );
  }
  if (ev.occurred_at) {
    metaChildren.push(el("span", { className: "event-date" }, [ev.occurred_at]));
  }

  const children: (Node | string)[] = [
    el("div", { className: "event-meta" }, metaChildren),
    el("div", { className: "event-title" }, [ev.title_vi]), // text node — never innerHTML
  ];

  // Source link only when the URL is an http(s) scheme (crawler URLs are semi-trusted).
  if (ev.news_url && /^https?:\/\//i.test(ev.news_url)) {
    children.push(
      el("a", {
        className: "event-source",
        href: ev.news_url,
        target: "_blank",
        rel: "noopener noreferrer",
      }, ["Xem bài gốc →"]),
    );
  }

  return el("div", { className: "event-card" }, children);
}
